import { prop } from 'ramda';
import qs from 'query-string';

import { wrapperRequest } from './utils';
import { API_URL, POST, PATCH, DELETE, OWN_ERR_HANDLER } from './consts';

export const postMedicalHistory = (body = {}) =>
  wrapperRequest({
    url: `${API_URL}/medicalhistories`,
    options: { method: POST, body },
  });

export const getMedicalHistory = (query = {}) =>
  wrapperRequest({
    url: `${API_URL}/medicalhistories?${qs.stringify(query)}`,
  });

export const patchMedicalHistory = (body = {}, query = {}) =>
  wrapperRequest({
    url: `${API_URL}/medicalhistories/${prop('medicalHistoryId', body)}?${qs.stringify(query)}`,
    options: { method: PATCH, body },
  });

export const getSearchableMedia = (id, body = {}) =>
  wrapperRequest({
    url: `${API_URL}/searchablemedia/${id}/search`,
    options: { method: POST, body, [OWN_ERR_HANDLER]: true },
  });

export const deleteSearchableMedia = (id) =>
  wrapperRequest({
    url: `${API_URL}/searchablemedia/${id}`,
    options: { method: DELETE },
  });

export const getDrugs = (query = {}) =>
  wrapperRequest({
    url: `${API_URL}/drugs?${qs.stringify(query)}`,
  });

export const patchDrug = (id, body, query = {}) =>
  wrapperRequest({
    url: `${API_URL}/drugs/${id}?${qs.stringify(query)}`,
    options: { method: PATCH, body },
  });

export const getPatientMedications = (query = {}) =>
  wrapperRequest({
    url: `${API_URL}/medications?${qs.stringify(query)}`,
  });

export const postMedication = (body, query = {}) =>
  wrapperRequest({
    url: `${API_URL}/medications?${qs.stringify(query)}`,
    options: { method: POST, body },
  });

export const patchMedication = (id, body, query = {}) =>
  wrapperRequest({
    url: `${API_URL}/medications/${id}?${qs.stringify(query)}`,
    options: { method: PATCH, body },
  });

export const deleteMedication = (id) =>
  wrapperRequest({
    url: `${API_URL}/medications/${id}`,
    options: { method: DELETE },
  });
